import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { EXRLoader } from 'three/addons/loaders/EXRLoader.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

const productModelEl = document.querySelector('[data-model-src]');

if (productModelEl) {
    const modelWidth = productModelEl.offsetWidth;
    const modelHeight = productModelEl.offsetHeight;
    const bgColor = productModelEl.dataset.bgColor;

    const shirtModel = new URL(productModelEl.dataset.modelSrc, import.meta.url).href;
    const studioModel = new URL('./environment/field.exr', import.meta.url).href;

    let mixer;
    let previousAction;
    let activeAction;
    const actions = {};
    const clock = new THREE.Clock();

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(bgColor);

    const camera = new THREE.PerspectiveCamera(45, modelWidth / modelHeight, 0.1, 1000);
    camera.position.set(0.5, 0.5, 1.5);

    const renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: 'high-performance' });
    renderer.setSize(modelWidth, modelHeight);
    renderer.setPixelRatio(window.devicePixelRatio);

    const canvas = renderer.domElement;

    const orbit = new OrbitControls(camera, renderer.domElement);
    orbit.enableDamping = true;
    orbit.enablePan = false;
    orbit.maxDistance = 2;
    orbit.minDistance = 0.5;
    orbit.maxPolarAngle = 2;
    orbit.minPolarAngle = 0.9;

    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;

    const exrLoader = new EXRLoader();
    exrLoader.load(studioModel, texture => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        scene.environment = texture;
    });

    // loader
    const loadingManager = new THREE.LoadingManager();
    const loadingBar = document.querySelector('[data-progress="model-loading"]');

    loadingManager.onProgress = (url, loaded, total) => {
        loadingBar.value = (loaded / total) * 100;
    }

    loadingManager.onLoad = () => {
        loadingBar.parentElement.remove();
        productModelEl.appendChild(canvas);
    }
    // endloader

    const loader = new GLTFLoader(loadingManager);
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderConfig({ type: 'js' });
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
    dracoLoader.setWorkerLimit(8);
    loader.setDRACOLoader(dracoLoader);

    loader.load(shirtModel, gltf => {
        const model = gltf.scene;
        const center = new THREE.Vector3(0, 0.85, 0);
        model.position.sub(center);

        mixer = new THREE.AnimationMixer(model);

        const clips = gltf.animations;
        clips.forEach(clip => (actions[clip.name] = mixer.clipAction(clip)));
        activeAction = actions['KeyAction.002'];
        fadeToAction(activeAction._clip.name);

        dracoLoader.dispose();
        scene.add(model);
    }, undefined, error => console.log(error));

    renderer.setAnimationLoop(animate);
    canvasResponsive(camera, renderer);

    canvas.addEventListener('mousedown', () => {
        canvas.classList.add('cursor-active');
    });
    canvas.addEventListener('mouseup', () => {
        canvas.classList.remove('cursor-active');
    });
    canvas.addEventListener('mouseleave', () => {
        canvas.classList.remove('cursor-active');
    });

    function animate () {
        mixer?.update(clock.getDelta());
        renderer.render(scene, camera);
    }

    function fadeToAction (name, duration = 0.5) {
        previousAction = activeAction;
        activeAction = actions[name] || null;

        if (previousAction !== activeAction) {
            previousAction?.fadeOut(duration);
        }

        activeAction?.reset().setEffectiveTimeScale(1).setEffectiveWeight(1).fadeIn(duration).play();
    }

    function canvasResponsive (camera, renderer) {
        window.addEventListener('resize', () => {
            camera.aspect = modelWidth / modelHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(modelWidth, modelHeight);
        });
    }
}
